import copy from 'copy-to-clipboard';

import { Tooltip } from 'components/Tooltip/Tooltip';

type Props = {
  copyText: string;
  successText?: string;
  children: React.ReactElement;
  onTooltipOpen?: () => void;
  onTooltipClose?: () => void;
  maxZIndex?: boolean;
};

export const Copy = (props: Props) => {
  const { copyText, successText, children, onTooltipOpen, onTooltipClose } = props;

  return (
    <Tooltip
      text={copyText ? (successText ?? 'Copied') : null}
      timeout={1000}
      onOpen={() => {
        copy(copyText);
        onTooltipOpen?.();
      }}
      onClose={onTooltipClose}
    >
      {children}
    </Tooltip>
  );
};
